// This icon file is generated automatically.
var PBookOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V.5A.5.5 0 0012 0zM7.94 1.13h1.5V4.4l-.73-.53-.77.56v-3.3zm3.43 11.75H2.63V1.12H7v4.64c0 .06.02.1.05.15.08.11.23.14.35.06l1.3-.94 1.28.93c.04.03.09.05.14.05.14 0 .25-.11.25-.25V1.13h1v11.75z", "fill-rule": "nonzero" } }] }, "name": "p-book", "theme": "outlined" };
export default PBookOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PBookOutlined.js
// module id = 3240
// module chunks = 0